import React, { useEffect } from 'react';

interface ComponentProps {
  forwardedRef: React.ForwardedRef<HTMLDivElement>;
  forwardedProps: React.HTMLAttributes<HTMLElement>;
  scrollPosition?: number;
}

function ListboxComponent({ forwardedRef, forwardedProps, scrollPosition }: ComponentProps) {
  const ref = React.createRef<HTMLUListElement>();

  useEffect(() => {
    if (ref && ref.current && scrollPosition !== undefined) {
      // Set back the scroll position within the dropdown
      // as it gets lost when a user toggle an item (due to re-render)
      ref.current.scrollTop = scrollPosition;
    }
  }, [ref, scrollPosition]);

  return (
    <div ref={forwardedRef}>
      <ul
        ref={ref}
         
        {...forwardedProps}
      />
    </div>
  );
}
export default ListboxComponent;
